<template>
    <div>
        <h3 v-if="contact && contact.nameFirst || contact && contact.nameLast">
            {{ contact && contact.nameFirst || ''
            }}<span v-if="contact && contact.nameFirst && contact && contact.nameLast">&nbsp;</span
            >{{ contact && contact.nameLast || '' }}
        </h3>
        <h3 v-else-if="contact && contact.nameCompany">{{ contact && contact.nameCompany }}</h3>
        <h4 v-if="contact && contact.nameCompany && (contact && contact.nameFirst || contact && contact.nameLast)">
            {{ contact && contact.nameCompany }}
        </h4>
    </div>
</template>
<script>
export default {
    props: {
        contact: {
            type: Object,
            default: null
        }
    }
}
</script>
